module.exports = __webpack_public_path__ + "img/14.c4e86009.png";